import React from "react";
import AppTemplate from "../components/Form1";

const Form1: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default Form1;
